import React from 'react';
import { colors } from 'globalStyle';
import { Title, Text } from 'components/Texts';
import {
  Divider, Grid, styled,
} from '@material-ui/core';

export default function ProjectRisks({ isDesktop, possibleRisks }) {
  return (
    <Grid container>
      <Title size={15}>
        Es importante que tengas en cuenta lo siguiente:
      </Title>
      {possibleRisks && (
        <>
          <Text mt={12} mb={22} size={isDesktop ? 15 : 14} style={{ whiteSpace: 'pre-line' }}>
            {possibleRisks}
          </Text>
          <StyledDivider />
          <Title mt={10} size={isDesktop ? 15 : 14}>
            La información contemplada no implica una recomendación de
            inversión ni el aseguramiento de retornos para tu inversión.
          </Title>
        </>
      )}

    </Grid>
  );
}

const StyledDivider = styled(Divider)({
  width: '100%',
  color: colors.GRAY_9,
});
